import React from 'react';
import Sidebar from './Sidebar';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex h-screen overflow-hidden bg-gray-50">
    <Sidebar />
    <main className="flex-1 flex flex-col min-h-0 overflow-y-auto">
      {children}
    </main>
  </div>
);

export default Layout;
